import { CustomFieldGroup_Entity } from "../../entities/customFieldGroup";
import { local420Api } from "../api/local420Api";

export const customFieldEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getMyCustomFields: build.query<CustomFieldGroup_Entity[], void>({
      query: () => `members/me/customFields`,
      providesTags: ["customFields"],
    }),
    updateMyCustomField: build.mutation<
      void,
      { organizationID: number; noteTypeID: number; value: string }
    >({
      query: (body) => ({
        method: "PUT",
        body,
        url: `members/me/customFields`,
      }),
      invalidatesTags: ["customFields"],
    }),
  }),
});

export const { useGetMyCustomFieldsQuery, useUpdateMyCustomFieldMutation } =
  customFieldEndpoints;

export default customFieldEndpoints;
